import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import Merci from "@/pages/Merci";
import NotFound from "@/pages/NotFound";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import CGV from "@/pages/legal/CGV";
import CGU from "@/pages/legal/CGU";
import Confidentialite from "@/pages/legal/Confidentialite";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/merci" element={<Merci />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/conditions-generales-de-vente" element={<CGV />} />
            <Route path="/conditions-generales-utilisation" element={<CGU />} />
            <Route path="/politique-de-confidentialite" element={<Confidentialite />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
